module.exports = __webpack_public_path__ + "img/clim_pack.cecaabad.png";